import { type IconColor } from '@direct-frontend/components';
import { type OpenApiSchemaSectionType } from '#shared/api/schema';

export function getConstructorSectionColor(sectionType: OpenApiSchemaSectionType): IconColor {
    switch (sectionType) {
        case 'parent':
        case 'child':
            return 'purple';
        case 'usual':
            return 'gray';

        default:
            return 'gray';
    }
}
